
import HeaderLandingPageThankYou from '~/components/HeaderLandingPageThankYou'
import YouGotBonuses from '~/components/ultimate-guide/thank-you/YouGotBonuses'
import ThrivingOnAPBDietDoesntHaveToBeADream from '~/components/ultimate-guide/thank-you/ThrivingOnAPBDietDoesntHaveToBeADream'
import YouCanAchieveTheHealthOfYourDreams from '~/components/ultimate-guide/thank-you/YouCanAchieveTheHealthOfYourDreams'
import IfTheyCanDoItSoCanYou from '~/components/ultimate-guide/thank-you/IfTheyCanDoItSoCanYou'
import HaveQuestionsContainer from '~/components/ultimate-guide/thank-you/HaveQuestionsContainer'
export default {
  name: 'QuickStartGuideThankYouPage',
  components: {
    HaveQuestionsContainer,
    IfTheyCanDoItSoCanYou,
    YouCanAchieveTheHealthOfYourDreams,
    ThrivingOnAPBDietDoesntHaveToBeADream,
    YouGotBonuses,
    HeaderLandingPageThankYou,
  },
  layout: 'landingpagefooter',
  data() {
    return {
      title: `The Plant-Based Quick Start Guide - ${this.$config.siteTitle}`,
      description:
        'Finally achieve your health goals and master plant-based eating with this jam-packed 60-page guide.',
    }
  },
  head() {
    return {
      title: this.title,
      meta: [
        {
          hid: 'description',
          name: 'description',
          content: this.description,
        },
        { hid: 'og:title', property: 'og:title', content: this.title },
        { hid: 'og:url', property: 'og:url', content: this.pageUrl },
        {
          hid: 'og:description',
          property: 'og:description',
          content: this.description,
        },

        // twitter card
        { hid: 'twitter:title', name: 'twitter:title', content: this.title },
        { hid: 'twitter:url', name: 'twitter:url', content: this.pageUrl },
        {
          hid: 'twitter:description',
          name: 'twitter:description',
          content: this.description,
        },
        {
          hid: 'og:image',
          name: 'og:image',
          content: '/images/ultimate-guide/og.png',
        },
        {
          hid: 'twitter:image',
          name: 'twitter:image',
          content: '/images/ultimate-guide/og.png',
        },
        {
          hid: 'og:image:width',
          name: 'og:image:width',
          content: '1200',
        },
        {
          hid: 'og:image:height',
          name: 'og:image:height',
          content: '630',
        },
      ],
    }
  },
}
